import SignUpPage from './components/SignUpPage'

export default SignUpPage
